<template>
  <div class="processItem">
    <div class="up">
      <div class="logo">
        <img :src="item.companyLogo1" />
        <el-tag size="small"> {{ item.version }} 版 </el-tag>
      </div>
      <div class="name">
        <el-badge v-if="item.status===1" :value="'上线'" type="warning">{{ item.name }}</el-badge>
        <el-badge v-else :value="'下线'" type="info">{{ item.name }}</el-badge>
      </div>
      <div class="date">
        <div>
          <font-awesome-icon :icon="['far', 'calendar-alt']" />&ensp;
          <span
              v-if="item.workdate === 1"
              >工作日</span
            >
            <span v-else>
              每日
            </span>
            &nbsp;&nbsp;
            {{item.starttime}}&nbsp;-&nbsp;
            {{item.endtime}}
        </div>
        
      </div>
    </div>
    <div class="down">
      <div class="comment">{{ item.comment }}</div>
      <div class="btns">
        <el-button
          size="small"
          icon="el-icon-video-play"
          @click="handleClickRun(item.id, item.name)"
          :disabled="item.status === 1"
          round
          >上线</el-button
        >
        <el-button
          size="small"
          icon="el-icon-video-pause"
          @click="handleClickStop(item.id, item.name)"
          :disabled="item.status === 0"
          round
          >下线</el-button
        >

        <el-button size="small" @click="handleClickConfig(item.id,item.name) "
          round
        >详细</el-button>
      </div>
    </div>
  </div>
</template>

<script>
//import { getDescriptionByCrontable } from "@/utils/robot/robot.js";
export default {
  name: "ProcessItem",
  props: {
    item: Object,
    handleClickRun: Function,
    handleClickStop: Function,
    handleClickConfig: Function
  }
};
</script>
<style>
.processItem {
  display: flex;
  flex-direction: column;
  height: 320px;
  width: 320px;
  margin: 0px 35px 35px 0px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
}
.processItem .up {
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  flex: 1;
  border-bottom: 1px solid #e5e5e5;
  background-color: #669966;
}
.processItem .up div {
  flex: 1;
}
.processItem .up .logo {
  display: flex;
  justify-content: space-between;
}
.processItem .up .logo img {
  max-height: 50px;
}
.processItem .up .name {
  color: #eee;
  font-size: 16px;
  font-weight: 600;
}

.processItem .up .date {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #ccc;
}
.processItem .down {
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  flex: 1;
}
.processItem .down .comment {
  font-size: 14px;
  color: #999;
}
.processItem .down .btns {
  display: flex;
  align-items: center;
}
.processItem .down div {
  flex: 1;
}
</style>
